import React, { useEffect, useState } from "react";
import { Button,Form, Select, Input, Col, Row,Divider, Upload, Icon, DatePicker, message } from 'antd';
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import {UploadOutlined} from "@ant-design/icons";
const { Option } = Select;


const { forwardRef, useRef, useImperativeHandle } = React;
export const PSForm = forwardRef((props, ref) => {
    const [form] = Form.useForm();
    const [InformedType] = useState([{ id: 0, name: 'YES' }, { id: 1, name: 'NO' }]);
    const [reportType] = useState([{ id: 0, name: 'पोस्ट' }, { id: 1, name: 'समक्ष' }]);
    const [isValidImage, setisValidImage] = useState(false);
    const [filelist, setfilelist] = useState([]);

    useEffect(() => {   
        dayjs.extend(weekday);
        dayjs.extend(localeData);
        dayjs.locale("en");
        dayjs.locale("vi");
        form.resetFields();
        setisValidImage(false);
        setfilelist([]);

    }, [props.data]);

    function beforeUpload(file) {
        let isImageAllowed = false;
        if(file.type.includes('jpg') || file.type.includes('jpeg') || file.type.includes('png')  || file.type.includes('pdf')){ 
            isImageAllowed = true;
        }else{
            message.error('You can only upload JPG/PNG/PDF file!');
            form.setFieldsValue({uploadpssheet:null})
        }
    
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          message.error('Image must smaller than 2MB!');
        }
    
        setisValidImage(isImageAllowed && isLt2M);
      }
      
      const fileuploadChange = (file)=> {
        if(file.event){
          if(isValidImage){
            file.file.status = 'success';
            setfilelist([file.file]);
          }else{
          }
        }    
      }

    useImperativeHandle(ref, () => ({
        onFinish(flag) {
            form.submit();
        },
    }));

    const onFinish = (values) => {
        if(isValidImage){
            values.crimedate = values.crimedate._d;
            values.uploadpssheet = {file: filelist[0], fileList: filelist}
            props.onFormFinish(values)
        }
    };


    const imageprops = {
        accept : "image/png, image/jpeg, image/jpg, application/pdf", 
        maxCount:1, 
        beforeUpload:beforeUpload,
        onChange:fileuploadChange,
        fileList: filelist
      }

    return (
        <Form onFinish={onFinish} form={form} layout="vertical">
            <Col>
                <Form.Item name="uploadpssheet" label="अपलोड ऍक्शन" rules={[{ required: true, message: "Please upload sheet" }]}>
                    <Upload {...imageprops}>
                        <Button type="uploadsheet" icon={<UploadOutlined />}> Click to Upload</Button>
                    </Upload>
                </Form.Item>
            </Col>

            <Col>
                <Form.Item name="informedtype" label="बजावता / न बजावता " rules={[{ required: true, message: "Please select type." }]}>
                    <Select placeholder="Select a option and change input text above" >
                        {InformedType && InformedType.length && InformedType.map(item => (
                            <Option key={item.id + item.name} value={item.name}>{item.name}</Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>

            <Col>
                <Form.Item name="posttype" label="अहवाल पाठवला (पोस्ट / समक्ष ) " rules={[{ required: true, message: "Please select type."}]}>
                    <Select placeholder="Select a option and change input text above" >
                        {reportType && reportType.length && reportType.map(item => (
                            <Option key={item.id + item.name} value={item.name}>{item.name}</Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>

            <Row gutter={24} style={{'display':'flex', alignItems:'end'}}>
                <Col span={12}>
                    <Form.Item name="finaldocno" label="जावक क्रमांक" rules={[{ required: true, message: "Please enter doc no"}]}>
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="crimedate"  rules={[{ required: true, message: "Please enter date" }]}>
                        <DatePicker name='getcrimedate' style={{ width: '100%' }}/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>

    );
});
